import { createStorage } from '@aviata/storage';

import { recentSearchesLib } from './lib';
import type { RecentSearch } from './types';

const STORAGE_KEY = 'free-avia:recent-searches';
const storage = createStorage(localStorage);

const getRecentSearches = (): RecentSearch[] => {
  const data = storage.parse(STORAGE_KEY);

  if (!recentSearchesLib.isRecentSearchesArray(data)) {
    return [];
  }

  const valid = recentSearchesLib.filterExpired(data);
  const sorted = recentSearchesLib.sortByTimestamp(valid);

  return recentSearchesLib.limitSearches(sorted);
};

const saveRecentSearch = (search: Omit<RecentSearch, 'timestamp'>): void => {
  const data = storage.parse(STORAGE_KEY);
  const existing = recentSearchesLib.isRecentSearchesArray(data) ? data : [];

  const newSearch: RecentSearch = {
    ...search,
    timestamp: Date.now(),
  };

  const deduped = existing.filter(
    s => !recentSearchesLib.isSameSearch(s, newSearch),
  );

  deduped.unshift(newSearch);

  const valid = recentSearchesLib.filterExpired(deduped);
  const sorted = recentSearchesLib.sortByTimestamp(valid);
  const limited = recentSearchesLib.limitSearches(sorted);

  storage.stringify(STORAGE_KEY, limited);
};

const clearRecentSearches = (): void => {
  storage.remove(STORAGE_KEY);
};

const removeRecentSearch = (timestamp: number): void => {
  const data = storage.parse(STORAGE_KEY);

  if (!recentSearchesLib.isRecentSearchesArray(data)) {
    return;
  }

  const next = data.filter(s => s.timestamp !== timestamp);
  storage.stringify(STORAGE_KEY, next);
};

export const recentSearches = {
  getRecentSearches,
  saveRecentSearch,
  clearRecentSearches,
  removeRecentSearch,
};
